<template>
  <div>
    <tool-tip style="float: right;" v-on:updateToolTip="updateToolTip($event)" v-if="agreementInformation_tooltip_NAME"  :name="agreementInformation_tooltip_NAME" :description="agreementInformation_tooltip_DESCRIPTION" :editable="editable"></tool-tip>
    <div class="row justify-content-left">

      <div class="col-md-2 content-right move-down">
        <AcsaModal :Id="agreementInfo.countryId"></AcsaModal>
      </div>
    </div>
    <div class="row justify-content-center">
      <div class="col-md-6">

        <label for="acsaAgreement">Support Agreement Nation 
        </label>
        <div style="display: inline;">
          <tool-tip style="position: relative ;z-index: 10;" v-on:updateToolTip="updateToolTip($event)" v-if="SupportAgreementNation_tooltip_NAME" :name="SupportAgreementNation_tooltip_NAME" :description="SupportAgreementNation_tooltip_DESCRIPTION" :editable="editable"></tool-tip>
        </div>

        <v-select
        id="acsaAgreement"
          :disabled="isReadOnly || isPartnerAccount || isSubmitted"
          v-model="agreementInfo.countryId"
          :reduce="(country) => country.countryId"
          label="name"
          name="supportAgreementNation"
          data-vv-as="Support Agreement Nation"
          :options="allCountries"
          placeholder="Select country"
          :class="errors.has('supportAgreementNation') ? 'has-danger' : ''"
          v-validate="'required'"
          :error="getError('supportAgreementNation')"
        ></v-select>
         <span v-show="errors.has('supportAgreementNation')" class="error"
          >Support Agreement Nation is required    
         </span>
      </div>
      <div class="col-md-6 text-align-center">
        <label for="organization">Organization</label>
        <span>
          <tool-tip v-on:updateToolTip="updateToolTip($event)" v-if="Organization_NAME" :name="Organization_NAME" :description="Organization_DESCRIPTION" :editable="editable"></tool-tip>
      </span>
          <v-select
            id="organization"
            :disabled="isReadOnly || isPartnerAccount ||isAuthorized"
            data-vv-as="Organization"
            v-model="agreementInfo.partnerOrganizationId"
            name="partnerOrganization"
            v-validate="'required'"
            :reduce="(org) => org.id"
            label="name"
            :options="countryOrganizations"
            placeholder="Select one"
             :class="errors.has('partnerOrganization') ? 'has-danger' : ''"
              :error="getError('partnerOrganization')"
          ></v-select>
           <span v-show="errors.has('partnerOrganization')" class="error"
          >Organization is required
         </span>
      </div>
    </div>
    <div class="row justify-content-left">
      <div  class="col-md-6 justify-content move-down">
        <IaModal :Id="agreementInfo.implimentArrangementId"></IaModal>
      </div>
    </div>
    <div class="row justify-content-center">
      <div class="col-md-6">
        <label for="implementArrangement">Implementing Arrangement</label>
        <span>
          <tool-tip style="position: relative ;z-index: 10;" v-on:updateToolTip="updateToolTip($event)" v-if="IA_NAME" :name="IA_NAME" :description="IA_DESCRIPTION" :editable="editable"></tool-tip>
      </span>
          <v-select
            id="implementArrangement"
            :disabled="isReadOnly || isPartnerAccount ||isAuthorized"
            v-model="agreementInfo.implimentArrangementId"
            name="implimentArrangement"
            :reduce="(ia) => ia.implimentArrangementId"
            label="name"
            :options="countryImplementArrangments"
            placeholder="Select an option"
          ></v-select>
      </div>
      <div class="col-md-6 text-align-center">
        <label for="operationTheater">Operation / Theater</label>   
        <!-- OperationTheater_NAME     -->
        <tool-tip v-on:updateToolTip="updateToolTip($event)" v-if="OperationTheater_NAME" :name="OperationTheater_NAME" :description="OperationTheater_DESCRIPTION" :editable="editable"></tool-tip>
          <v-select
          id="operationTheater"
            :disabled="isReadOnly || isPartnerAccount ||isAuthorized"
            data-vv-as="Operation / Theater"
            v-model="agreementInfo.theaterId"
            name="theaterId"
            v-validate="'required'"
            :reduce="(operationTheatre) => operationTheatre.theaterId"
            label="name"
            :options="allOperationTheatres"
            placeholder="Select one"
            :class="errors.has('theaterId') ? 'has-danger' : ''"
            :error="getError('theaterId')"
          ></v-select>
            <span v-show="errors.has('theaterId')" class="error"
          >Operation / Theater is required
         </span>
      </div>
    </div>
    <div class="row justify-content-right">
      <div class="col-md-12 align-right">
        <base-button
          :disabled="isReadOnly || isPartnerAccount"
          type="primary"
          wide
          @click.native="submit"
          class="btn-next"
          >Save</base-button
        >
        <div class="clearfix"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Utility from "@/mixins/utility/utility";
import IaModal from "@/components/App/order/submission/agreement/AgreementInformationIaModal.vue";
import AcsaModal from "@/components/App/order/submission/agreement/AgreementInformationAcsaModal.vue";
import  toolTip  from "../../../Tooltip";

export default {
  props: ["isReadOnly"],
  name: "AgreementInformation",
  data () {
    return {
      agreementInformation_tooltip_NAME: '',
      agreementInformation_tooltip_DESCRIPTION: '',
      SupportAgreementNation_tooltip_DESCRIPTION: '',
      SupportAgreementNation_tooltip_NAME:'',
      Organization_NAME:'',
      Organization_DESCRIPTION:'',
      OperationTheater_DESCRIPTION: '',
      OperationTheater_NAME: '',
      IA_DESCRIPTION:'',
      IA_NAME:''

    };
  },
  mixins: [Utility],
  async mounted() {
    await this.getAllTooltips()
    this.loadToolTips()
  
  },
  components: {
    IaModal,
    AcsaModal,
    toolTip
  },
  computed: {
    ...mapGetters({
      allCountries: "countries/activeCountries",
      countryUpdated:"implementArrangment/countryUpdated",
      allOperationTheatres: "operationTheaters/allOperationTheatres",
      countryImplementArrangments:
        "implementArrangment/countryImplementArrangments",
      countryOrganizations: "organization/countryOrganizations",
      agreementInfo: "agreementInformation/agreementInfo",
      agreementInfoSelectedCountryId:
        "agreementInformation/agreementInfoSelectedCountryId",
      agreementInfoErrors: "agreementInformation/agreementInfoErrors",
      isPartnerAccount: "authentication/isPartnerAccount",
      toolTips: "tooltip/tooltips",
      editable: "tooltip/editable",
      isAuthorized: "orderMetadata/isAuthorized",
      isSubmitted: "orderMetadata/isSubmitted",


    }),
    getOrderIdFromRoute() {
      return parseInt(this.$route.params.id);
    },
  },
  methods: {
    ...mapActions({
      getAllCountries: "countries/getAllActiveCountries",
      getAllOperationTheatres: "operationTheaters/getAllOperationTheatres",
      getCountryImplementArrangments:
        "implementArrangment/getCountryImplementArrangments",
      getCountryUpdatedCount: "implementArrangment/getCountryUpdatedCount",
      getCountryOrganizations: "organization/getCountryOrganizations",
      getAgreementInformationStatus:
        "agreementInformation/getAgreementInformationStatus",
      agreementInformationCountryChanged:
        "agreementInformation/agreementInformationCountryChanged",
      loadAgreementInformation: "agreementInformation/loadAgreementInformation",
      saveAggreementInfoToServer: "agreementInformation/saveAgreementInfoToServer",
      getAllTooltips: "tooltip/getToolTips"
    }),
    loadToolTips(){
    const aggreementInfo = this.toolTips.find(e => e.name === "AgreementInformationModule")
    const SupportAgreementNation_tooltip = this.toolTips.find(e => e.name === "SupportAgreementNation")
    const Organization_tooltip = this.toolTips.find(e => e.name === "Organization")
    const OperationTheater_tooltip = this.toolTips.find(e => e.name === "OperationTheater")
    const IA_tooltip = this.toolTips.find(e => e.name === "OperationTheater")

    if(OperationTheater_tooltip.status){
      this.OperationTheater_DESCRIPTION = OperationTheater_tooltip.description ? OperationTheater_tooltip.description :  null
      this.OperationTheater_NAME = OperationTheater_tooltip.name ? OperationTheater_tooltip.name :  null
    }
    if(IA_tooltip.status){
      this.IA_DESCRIPTION = IA_tooltip.description ? IA_tooltip.description :  null
      this.IA_NAME = IA_tooltip.name ? IA_tooltip.name :  null
    }
    if(Organization_tooltip.status){
      this.Organization_DESCRIPTION = Organization_tooltip.description ? Organization_tooltip.description :  null
      this.Organization_NAME = Organization_tooltip.name ? Organization_tooltip.name :  null
    }
    if(SupportAgreementNation_tooltip.status){
      this.SupportAgreementNation_tooltip_DESCRIPTION = SupportAgreementNation_tooltip.description ? SupportAgreementNation_tooltip.description :  null
      this.SupportAgreementNation_tooltip_NAME = SupportAgreementNation_tooltip.name ? SupportAgreementNation_tooltip.name :  null
    }
    if(aggreementInfo.status){
      this.agreementInformation_tooltip_DESCRIPTION = aggreementInfo.description ? aggreementInfo.description :  null
      this.agreementInformation_tooltip_NAME = aggreementInfo.name ? aggreementInfo.name :  null
    }
    return 
      
    },
    updateToolTip(updatedData){
      this.loadToolTips()
      },
    loaded() {
      this.getAllCountries();
      this.getAllOperationTheatres();
      this.$validator.errors.clear();

      if(this.getOrderIdFromRoute !== 0) {
        this.loadAgreementInformation(this.getOrderIdFromRoute);
      }
    },
    showAgreementInfoErrors () {
      if(this.agreementInfoErrors.length > 0 ) {
        this.agreementInfoErrors.forEach(error => this.$toast.error(error))
      } 
    },
    async submit(e) {
      let ctx = this;
      this.$validator.validateAll().then((result) => {
        if (result) {
          ctx.saveAggreementInfoToServer(this.getOrderIdFromRoute).then((response) => {
              ctx.getAgreementInformationStatus(ctx.getOrderIdFromRoute).then(() => {
                  ctx.showAgreementInfoErrors();
                });
              ctx.loadAgreementInformation(ctx.getOrderIdFromRoute);
            })
            .catch((errorMessage) => {
              //console.log(errorMessage) //not handelled
            });
        } else {
          this.$toast.error("Please fill the required fields.");
        }
      });
    },
    validateOrganization(value) {
      let result = this.countryOrganizations.find((org) => {
        return org.id === value;
      });

      return result ? result.id : null;
    },
    validateIA(value) {
      let result = this.countryImplementArrangments.find((ia) => {
        return ia.implimentArrangementId === value;
      });

      return result ? result.implimentArrangementId : null;
    },
    getError(fieldName) {
      return this.errors.first(fieldName);
    },
  },
  watch: {
    agreementInfoSelectedCountryId() {
      if (this.$route.params.id <= 0 || this.agreementInfoSelectedCountryId <= 0) return;

      let ctx = this;
      ctx.agreementInfo.partnerOrganizationId = ''
      ctx
        .getCountryOrganizations(ctx.agreementInfoSelectedCountryId)
          //first
          ctx
            .getCountryImplementArrangments(ctx.agreementInfoSelectedCountryId)
            .then(() => {
              // next
              ctx.agreementInformationCountryChanged({
                //finally
                partnerOrganizationId: ctx.validateOrganization(
                  ctx.agreementInfo.partnerOrganizationId
                ),
                
                implimentArrangementId: ctx.validateIA(
                  ctx.agreementInfo.implimentArrangementId
                ),
              });
              
            }).then(
              this.getCountryUpdatedCount(1)
            );
    },
  },
};
</script>

<style scoped>
.move-down {
  position: relative;
  top: 28px;
  z-index: 1;
}
  @media (max-width: 820px) {
.text-align-center{
text-align: center;
  }
}
</style>
